import { BlockProps } from '../../types'
import Stack from '@mui/material/Stack'
import { getLayoutConfig } from './layout'

import type { SVGImageBlockData } from '../../../../core/types/InsightsInstanceSlotData'

import { ThemedSVGImage } from '../../../components/chartblocks/ThemedSVGImage'

export const SVGImageBlock = ({
  payload: { instance_slot, instance_slot_data, widget_type },
}: BlockProps<SVGImageBlockData>) => {
  const isMini = widget_type === 'mini'
  const { variant } = instance_slot
  const layoutConfig = getLayoutConfig(variant, instance_slot_data?.isCIBC)

  // TODO : Add Designate Emergency Savings Account dropdown, post discussion with BE design.
  return (
    <Stack alignItems="center" sx={{ width: '100%' }}>
      <ThemedSVGImage image={layoutConfig.image} isMini={isMini} />
    </Stack>
  )
}
